// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512011203/js/" + chunkId + "." + {"44":"e921d470","225":"d54355ac","481":"c00a5930","486":"9d7ddf3a","770":"a865d0e7"}[chunkId] + ".0.307009303635863.chunk.js";
};